<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 report p-3">
        <div slot="with-padding">
          <div class="col-md-12 quick-stats-container">
            <!-- Header with Title and Timer -->
            <div class="quick-stats-header">
              <h2 class="quick-stats-title">Quick Stats</h2>
              <div class="update-timer">
                <div class="timer-text">
                  <div>LAST UPDATED</div>
                  <div class="timer-text-value">{{ lastUpdatedTime }}</div>
                </div>
                <div class="timer-divider"></div>
                <div class="timer-text">
                  <div>NEXT UPDATE IN</div>
                  <div class="timer-text-value">{{ nextUpdateIn }} Sec.</div>
                </div>
              </div>
            </div>

            <!-- No Data State -->
            <div v-if="totalMonitors == 0" class="no-data-wrapper">
              <img src="../assets/icons/data-not-found.svg" alt="Data Not Found" class="no-data-image" />
            </div>

            <!-- Stats Content -->
            <div v-else class="stats-content-wrapper">
              <div class="stats-row">
                <!-- UP Monitors -->
                <div class="stat-card">
                  <router-link class="stat-link" :to="{ path: '/app/monitor?type=up' }">
                    <div class="circle-chart">
                      <svg width="243" height="243" viewBox="0 0 243 243" xmlns="http://www.w3.org/2000/svg">
                        <g transform="rotate(-90 121.5 121.5)">
                          <!-- Background circle -->
                          <circle r="100" cy="121.5" cx="121.5" stroke-width="22" stroke="#F2F7FF" fill="none"></circle>
                          <!-- Progress circle -->
                          <circle r="100" cy="121.5" cx="121.5" stroke-width="22" stroke="#188007" fill="none"
                            stroke-dasharray="628" :stroke-dashoffset="628 - (628 * (monitor_report.up / (totalMonitors || 1)))"
                            stroke-linecap="straght"
                            style="transition: stroke-dashoffset 0.6s ease;"></circle>
                        </g>
                      </svg>
                      <div class="circle-value">{{ monitor_report.up }}</div>
                    </div>
                    <div class="stat-label">
                      <span class="status-icon up-icon"></span>
                      <span class="label-text">Up Monitors</span>
                    </div>
                  </router-link>
                </div>

                <div class="stat-divider"></div>

                <!-- Down Monitors -->
                <div class="stat-card">
                  <router-link class="stat-link" :to="{ path: '/app/monitor?type=down' }">
                    <div class="circle-chart">
                      <svg width="243" height="243" viewBox="0 0 243 243" xmlns="http://www.w3.org/2000/svg">
                        <g transform="rotate(-90 121.5 121.5)">
                          <!-- Background circle -->
                          <circle r="100" cy="121.5" cx="121.5" stroke-width="22" stroke="#F2F7FF" fill="none"></circle>
                          <!-- Progress circle -->
                          <circle r="100" cy="121.5" cx="121.5" stroke-width="22" stroke="#F20707" fill="none"
                            stroke-dasharray="628" :stroke-dashoffset="628 - (628 * (monitor_report.down / (totalMonitors || 1)))"
                            stroke-linecap="straght"
                            style="transition: stroke-dashoffset 0.6s ease;"></circle>
                        </g>
                      </svg>
                      <div class="circle-value">{{ monitor_report.down }}</div>
                    </div>
                    <div class="stat-label">
                      <span class="status-icon down-icon"></span>
                      <span class="label-text">Down Monitors</span>
                    </div>
                  </router-link>  
                </div>

                <div class="stat-divider"></div>

                <!-- Paused Monitors -->
                <div class="stat-card">
                  <router-link class="stat-link" :to="{ path: '/app/monitor?type=pause' }">
                    <div class="circle-chart">
                      <svg width="243" height="243" viewBox="0 0 243 243" xmlns="http://www.w3.org/2000/svg">
                        <g transform="rotate(-90 121.5 121.5)">
                          <!-- Background circle -->
                          <circle r="100" cy="121.5" cx="121.5" stroke-width="22" stroke="#F2F7FF" fill="none"></circle>
                          <!-- Progress circle -->
                          <circle r="100" cy="121.5" cx="121.5" stroke-width="22" stroke="#C1C1C1" fill="none"
                            stroke-dasharray="628" :stroke-dashoffset="628 - (628 * (monitor_report.pause / (totalMonitors || 1)))"
                            stroke-linecap="straght"
                            style="transition: stroke-dashoffset 0.6s ease;"></circle>
                        </g>
                      </svg>
                      <div class="circle-value">{{ monitor_report.pause }}</div>
                    </div>
                    <div class="stat-label">
                      <span class="status-icon pause-icon"></span>
                      <span class="label-text">Pause Monitors</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import DashboardController from "../../services/dashboardController";
import moment from 'moment';

export default {
  name: "report",
  components: {},
  data() {
    return {
      monitor_report: { up: 0, down: 0, pause: 0 },
      totalMonitors: 0,
      lastUpdatedTime: '',
      nextUpdateIn: 60,
      updateInterval: null,
      countdownInterval: null,
    };
  },
  mounted() {
    this.getData();
    this.startAutoUpdate();
    this.startCountdown();
  },
  beforeDestroy() {
    // Clear intervals when component is destroyed
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },
  methods: {
    async getData() {
      let response = await DashboardController.getMonitorReport();
      if (response.message) {
        if (response.data.up) { this.monitor_report.up = response.data.up; }
        if (response.data.down) { this.monitor_report.down = response.data.down; }
        if (response.data.pause) { this.monitor_report.pause = response.data.pause; }
        this.totalMonitors = response.data.up + response.data.down + response.data.pause;
        
        // Update last updated time
        this.lastUpdatedTime = moment().format('h:mm:ss A');
        // Reset countdown
        this.nextUpdateIn = 60;
      }
    },
    startAutoUpdate() {
      // Update data every 60 seconds
      this.updateInterval = setInterval(() => {
        this.getData();
      }, 60000);
    },
    startCountdown() {
      // Update countdown every second
      this.countdownInterval = setInterval(() => {
        if (this.nextUpdateIn > 0) {
          this.nextUpdateIn--;
        } else {
          this.nextUpdateIn = 60;
        }
      }, 1000);
    },
  },
};
</script>


<style scoped>
/* Quick Stats Container */
.quick-stats-container {
  padding: 30px;
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
}

/* Header Section */
.quick-stats-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}

.quick-stats-title {
  font-family: 'Poppins', sans-serif;
  font-size: 30px;
  font-weight: 600;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0;
}

/* Timer Section */
.update-timer {
  display: flex;
  align-items: center;
  gap: 20px;
}

.timer-text {
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.5em;
  letter-spacing: 1.4285714%;
  color: #000000;
}

.timer-text-value{
  font-weight: 600;
  letter-spacing: 0.2px;
}

.timer-divider {
  width: 1px;
  height: 40px;
  background-color: #D2E3FB;
}

/* Stats Content */
.stats-content-wrapper {
  background: #FFFFFF;
  padding: 10px;
}

.stats-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

/* Stat Card */
.stat-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  flex: 1;
}

.stat-link {
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.stat-link:hover {
  text-decoration: none;
}

/* Dividers between stats */
.stat-divider {
  width: 1px;
  height: 240px;
  background-color: #D2E3FB;
  flex-shrink: 0;
}

/* Circle Chart */
.circle-chart {
  position: relative;
  width: 243px;
  height: 243px;
}

.circle-chart svg {
  width: 100%;
  height: 100%;
}

.circle-value {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: 'Poppins', sans-serif;
  font-size: 80px;
  font-weight: 600;
  line-height: 0.925em;
  color: #161616;
}

/* Stat Label */
.stat-label {
  display: flex;
  align-items: center;
  gap: 10px;
}

.status-icon {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-block;
}

.up-icon {
  background-color: #188007;
}

.down-icon {
  background-color: #F20707;
}

.pause-icon {
  background-color: #C1C1C1;
}

.label-text {
  font-family: 'Poppins', sans-serif;
  font-size: 26px;
  font-weight: 500;
  line-height: 0.915em;
  color: #3A3A3A;
}

/* No Data State */
.no-data-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  gap: 19px;
  min-height: 300px;
}

.no-data-image {
  width: 318px;
  height: 283px;
  object-fit: contain;
}

.no-data-text {
  font-family: 'Poppins', sans-serif;
  font-size: 26px;
  font-weight: 400;
  line-height: 0.915em;
  color: #3A3A3A;
  margin: 0;
  text-align: center;
}

/* Responsive */
@media (max-width: 1200px) {
  .stats-row {
    flex-direction: column;
    gap: 30px;
  }

  .stat-divider {
    width: 80%;
    height: 1px;
    margin: 0 auto;
  }

  .quick-stats-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }

  .update-timer {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .quick-stats-container {
    padding: 20px;
  }

  .quick-stats-title {
    font-size: 24px;
  }

  .timer-text {
    font-size: 12px;
  }

  .no-data-image {
    width: 250px;
    height: 220px;
  }

  .no-data-text {
    font-size: 22px;
  }

  .circle-chart {
    width: 180px;
    height: 180px;
  }

  .circle-chart svg {
    transform: scale(0.74);
    transform-origin: center;
  }

  .circle-value {
    font-size: 60px;
  }

  .status-icon {
    width: 24px;
    height: 24px;
  }

  .label-text {
    font-size: 20px;
  }

  .stat-divider {
    height: 1px;
  }
}

@media (max-width: 576px) {
  .no-data-image {
    width: 200px;
    height: 180px;
  }

  .no-data-text {
    font-size: 20px;
  }

  .circle-chart {
    width: 150px;
    height: 150px;
  }

  .circle-chart svg {
    transform: scale(1.25);
  }

  .circle-value {
    font-size: 50px;
  }

  .status-icon {
    width: 20px;
    height: 20px;
    border-radius: 6px;
  }

  .label-text {
    font-size: 18px;
  }
}
</style>